import { v4 as uuidv4 } from 'uuid';

const V2_SITE_KEY = '6LfGCV0iAAAAAAeVH_srTbQdNrzpN5H1iMmw6Tbx';
const V3_SITE_KEY = '6LcXBl0iAAAAAGqOOltGfa2sD9lCE4E-Jr9gWJ27'; // tslint:disable-line
const SITE_URL = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaV3Callback&render=6LcXBl0iAAAAAGqOOltGfa2sD9lCE4E-Jr9gWJ27';
const V2_SITE_URL = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=6LfGCV0iAAAAAAeVH_srTbQdNrzpN5H1iMmw6Tbx';

const reCaptchaService = (() => {
//   (function (d, s, id, obj) {
//     let js: any;
//     const fjs = d.getElementsByTagName(s)[0];
//       if (d.getElementById(id)) {
//         renderV3ReCaptch();
//         return;
//       }
//       console.warn(id);
//       js = d.createElement(s) as HTMLScriptElement;
//       js.id = id;
//       js.src = SITE_URL;
//       fjs &&
//       fjs.parentNode &&
//       fjs!.parentNode!.insertBefore(js, fjs);
//   }(document, 'script', `recaptcha${uuidv4()}`, this));

  async function initailizeV3Captcha() {
    // debugger;
    (window as { [key: string]: any })['grecaptchaV3Callback'] = () => {
      renderV3ReCaptch();
    };
    let js: any;
    const fjs = document.getElementsByTagName('script')[0];
    if (document.getElementById(`recaptcha${uuidv4()}`)) {
      renderV3ReCaptch();
      return;
    }
    console.warn(`recaptcha${uuidv4()}`);
    js = document.createElement('script') as HTMLScriptElement;
    js.id = `recaptcha${uuidv4()}`;
    js.src = SITE_URL;
    fjs &&
    fjs.parentNode &&
    fjs!.parentNode!.insertBefore(js, fjs);
    // (window as { [key: string]: any })['grecaptchaV3'] = (window as { [key: string]: any })['grecaptcha'];
  }

  async function renderV3ReCaptch() {
    // console.warn((window as { [key: string]: any })['grecaptchaV3']);
    let captchaResponse = {}; // tslint:disable-line
    console.warn((window as { [key: string]: any })['grecaptcha']);
    (window as { [key: string]: any })['grecaptcha'].ready(() => {
      (window as { [key: string]: any })['grecaptcha'].execute('6LcXBl0iAAAAAGqOOltGfa2sD9lCE4E-Jr9gWJ27', { action:'submit' })
        .then((token:any) =>  {
          // add token value to form
          // recaptchaID?.nodeValue = token
          console.warn('token:  ', token);
          (window as { [key: string]: any }).document.getElementById('recaptcha').value = token;
          captchaResponse = { recaptcha:token, validCaptcha: true };
        });
    });
  }

  async function initailizeV2Captcha(id:any) {
    (window as { [key: string]: any })['grecaptchaCallback'] = () => {
      renderReCaptch(id);
    };
    let js: any;
    const fjs = document.getElementsByTagName('script')[0];
    if (document.getElementById(`recaptcha${uuidv4()}`)) {
      renderReCaptch(id);
      return;
    }
    console.warn(`recaptcha${uuidv4()}`);
    js = document.createElement('script') as HTMLScriptElement;
    js.id = `recaptcha${uuidv4()}`;
    js.src = V2_SITE_URL;
    js.onerror = () => {
      onCaptchaLoadError();
    };
    fjs &&
    fjs.parentNode &&
    fjs!.parentNode!.insertBefore(js, fjs);
    // (window as { [key: string]: any })['grecaptchaV2'] =  (window as { [key: string]: any })['grecaptcha'];
  }

  async function renderReCaptch(id:any) {
    console.warn('inside render recaptcha');
    // console.warn((window as { [key: string]: any })['grecaptchaV2']);
    let captchaResponse = {};// tslint:disable-line
    if ((window as { [key: string]: any })['grecaptcha'] === undefined ||
      (window as { [key: string]: any })['grecaptcha'] === null) {
      onCaptchaLoadError();
      return;
    }
    const recaptchaID = document.getElementById(id);
    console.warn(recaptchaID);
    if (recaptchaID) {
      (window as { [key: string]: any })['grecaptcha'].ready(() => {
        (window as { [key: string]: any })['grecaptcha'].render(recaptchaID, {
          sitekey : V2_SITE_KEY,
          callback: (response: any) => {
            captchaResponse = { recaptcha:response, validCaptcha: true };
          },
          'expired-callback': () => {
            (window as { [key: string]: any })['grecaptcha'].reset();
            captchaResponse = { recaptcha: '', validCaptcha: false };
          },
          'error-callback': () => {
            onCaptchaLoadError();
            console.error('captcha error');
          },
        });
      });
    }
  }

  function onCaptchaLoadError() {

  }

  return {
    initailizeV3Captcha,
    initailizeV2Captcha,
    renderReCaptch,
    renderV3ReCaptch,
    onCaptchaLoadError,
  };
})();

export default reCaptchaService;
